import { Badge } from "@/components/ui/badge";
import { useTranslation } from "react-i18next";
import { PaymentMethod } from "@/types/orders";
import { CreditCard, Banknote, Receipt } from "lucide-react";

interface PaymentMethodBadgeProps {
  method: PaymentMethod;
}

export function PaymentMethodBadge({ method }: PaymentMethodBadgeProps) {
  const { t } = useTranslation();

  const getPaymentMethodInfo = (method: PaymentMethod) => {
    switch (method) {
      case "Digital":
        return {
          label: t("paymentMethods.Digital"),
          icon: CreditCard,
          className: "bg-blue-100 text-blue-800 border-blue-200",
        };
      case "Cash":
        return {
          label: t("paymentMethods.Cash"),
          icon: Banknote,
          className: "bg-green-100 text-green-800 border-green-200",
        };
      case "Visa":
        return {
          label: t("paymentMethods.Visa"),
          icon: CreditCard,
          className: "bg-indigo-100 text-indigo-800 border-indigo-200",
        };
      case "Mastercard":
        return {
          label: t("paymentMethods.Mastercard"),
          icon: CreditCard,
          className: "bg-orange-100 text-orange-800 border-orange-200",
        };
      case "Paypal":
        return {
          label: t("paymentMethods.Paypal"),
          icon: Receipt,
          className: "bg-blue-100 text-blue-800 border-blue-200",
        };
      case "Apple Pay":
        return {
          label: t("paymentMethods.Apple Pay"),
          icon: CreditCard,
          className: "bg-gray-100 text-gray-800 border-gray-200",
        };
      case "Google Pay":
        return {
          label: t("paymentMethods.Google Pay"),
          icon: CreditCard,
          className: "bg-gray-100 text-gray-800 border-gray-200",
        };
      default:
        return {
          label: t("paymentMethods.unknown"),
          icon: Receipt,
          className: "bg-gray-100 text-gray-800 border-gray-200",
        };
    }
  };

  const { label, icon: Icon, className } = getPaymentMethodInfo(method);

  return (
    <Badge variant="outline" className={`flex items-center gap-1 ${className}`}>
      <Icon className="h-3 w-3" />
      <span>{label}</span>
    </Badge>
  );
}
